import { Flex, Stack, Title } from '@mantine/core';
import classes from './DevTools.module.css';

type DevToolsCardProps = {
  children: React.ReactNode;
  title: string;
};

const DevToolsCard = ({ children, title }: DevToolsCardProps) => {
  return (
    <Flex direction="column" gap="md" className={classes.devToolsCard}>
      <Stack m="lg" h="100%">
        <Title order={3} fw="bolder" fs="35">
          {title}
        </Title>
        {children}
      </Stack>
    </Flex>
  );
};

export default DevToolsCard;
